import React, { useEffect, useState } from 'react';
import { Snackbar, Alert } from '@mui/material';

const isNetworkError = (reason) => Boolean(reason?.isAxiosError) && !reason.response;

export default function NetworkErrorNotifier() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (event) => {
      if (!isNetworkError(event.reason)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      setOpen(true);
    };
    window.addEventListener('unhandledrejection', handler, true);
    return () => window.removeEventListener('unhandledrejection', handler, true);
  }, []);

  return (
    <Snackbar open={open} autoHideDuration={6000} onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
      <Alert severity="error" variant="filled" onClose={() => setOpen(false)}>
        No se pudo conectar con el servidor. Verifica que el backend esté activo e intenta de nuevo.
      </Alert>
    </Snackbar>
  );
}
